import { featureFlags } from '@seen/core/featureFlags'
import { invariant } from '@seen/core/invariant'
import type { JSX } from 'react'
import { useParams } from 'react-router'
import { useFeatureFlag } from '#src/hooks/useFeatureFlag.ts'
import { DeskPage } from '#src/pages/desks/DeskPage.tsx'

// Route element for the global `/desks/:deskId` route. React Router reuses a
// route element instance when only a param changes, so without a key a
// desk-to-desk navigation keeps the mounted desk subtree — and with it the
// Liveblocks-backed flow store, whose `nodes` survive `leaveRoom` and are then
// seeded into the next desk's room by `enterRoom`. Keying on `deskId` remounts
// the subtree that owns that store. `ParticipantDeskPage` already keys the
// participant-scoped route the same way; this makes the two consistent.
export function DeskRoutePage(): JSX.Element {
  const { deskId } = useParams()
  invariant(deskId, 'Desk ID is required')
  const remountPerDesk = useFeatureFlag(featureFlags.deskRouteRemount)
  return <DeskPage key={remountPerDesk ? deskId : undefined} />
}
